import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Log from 'models/log/log.model';
import { TokenService } from 'services/token/token-service.service';
import { ConfigService } from 'services/config/config.service';
import { UserService } from 'services/user/user.service';
import { LogService } from 'services/log/log.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor(
    public router: Router,
    public tokenService: TokenService,
    public userService: UserService,
    public logService: LogService,
    public configService: ConfigService,
  ) { }

  public async init(): Promise<boolean> {
    return new Promise(async (resolve: (r: boolean) => any, reject: (e: Error) => any) => {
      try {
        await this.configService.readConfig();
        return resolve(true);
      } catch (ex) {
        await this.logService.create(new Log({
          event: 'serviceError',
          description: ex.stack,
          performer: 'AppService.init',
          type: 'error',
        }));
        return reject(new Error('initError'));
      }
    });
  }

  public async logout() {
    return new Promise(async (resolve: (r: boolean) => any, reject: (e: Error) => any) => {
      await this.tokenService.removeOidcData();
      window.location.href = this.configService.getConfig().oidcLogoutUrl;
      resolve(undefined);
    });
  }
}
